import {
    SURVEY_YEAR_2022_2023,
    SURVEY_YEAR_2023,
    SURVEY_YEAR_2023_PRELIM,
    SURVEY_YEAR_2023_2024,
    SURVEY_YEAR_2024,
    SURVEY_YEAR_2024_2025,
    SURVEY_YEAR_2025,
    SURVEY_YEAR_2025_2026_PRELIM,
    SURVEY_YEAR_2025_2026,
    SURVEY_YEAR_2026_PRELIM,
    SURVEY_YEAR_2026,
    SURVEY_YEAR_2026_2027_PRELIM,
    SURVEY_YEAR_2026_2027,
    SURVEY_YEAR_2027_PRELIM,
} from './constants'

const NORTH_AMERICA_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'United States', label: 'United States' },
        { value: 'Canada', label: 'Canada' },
        { value: 'Mexico', label: 'Mexico' },
    ],
}

const LATIN_AMERICA_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
    ],
    [SURVEY_YEAR_2023]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2023_2024]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2024]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2024_2025]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2025]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2025_2026_PRELIM]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2025_2026]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'El Salvador', label: 'El Salvador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2026_2027_PRELIM]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
    [SURVEY_YEAR_2026_2027]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'El Salvador', label: 'El Salvador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
        { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
    ],
    [SURVEY_YEAR_2027_PRELIM]: [
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Chile', label: 'Chile' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Puerto Rico', label: 'Puerto Rico' },
        { value: 'Uruguay', label: 'Uruguay' },
    ],
}

const AFRICA_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
    ],
    [SURVEY_YEAR_2023]: [
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
    ],
    [SURVEY_YEAR_2023_2024]: [
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Ghana', label: 'Ghana' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
    ],
    [SURVEY_YEAR_2024]: [
        { value: 'Algeria', label: 'Algeria' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Ethiopia', label: 'Ethiopia' },
        { value: 'Ghana', label: 'Ghana' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
        { value: 'Tanzania', label: 'Tanzania' },
    ],
    [SURVEY_YEAR_2024_2025]: [
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'South Africa', label: 'South Africa' },
    ],

    [SURVEY_YEAR_2025]: [
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Ghana', label: 'Ghana' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'Senegal', label: 'Senegal' },
        { value: 'South Africa', label: 'South Africa' },
        { value: 'Tunisia', label: 'Tunisia' },
    ],
    [SURVEY_YEAR_2025_2026_PRELIM]: [
        { value: 'Algeria', label: 'Algeria' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Ghana', label: 'Ghana' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
    ],
    [SURVEY_YEAR_2025_2026]: [
        { value: 'Algeria', label: 'Algeria' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Ghana', label: 'Ghana' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
    ],
    [SURVEY_YEAR_2026_PRELIM]: [
        { value: 'Algeria', label: 'Algeria' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
    ],
    [SURVEY_YEAR_2026_2027_PRELIM]: [
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
    ],
    [SURVEY_YEAR_2026_2027]: [
        { value: 'Algeria', label: 'Algeria' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
        { value: 'Tanzania', label: 'Tanzania' },
        { value: 'Tunisia', label: 'Tunisia' },
    ],
    [SURVEY_YEAR_2027_PRELIM]: [
        { value: 'Algeria', label: 'Algeria' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'South Africa', label: 'South Africa' },
        { value: 'Tunisia', label: 'Tunisia' },
    ],
}

const ASIA_COUNTY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Sri Lanka', label: 'Sri Lanka' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2023]: [
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2023_2024]: [
        { value: 'Bahrain', label: 'Bahrain' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2024]: [
        { value: 'Bahrain', label: 'Bahrain' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2024_2025]: [
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2025]: [
        { value: 'Bahrain', label: 'Bahrain' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Sri Lanka', label: 'Sri Lanka' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2025_2026_PRELIM]: [
        { value: 'Bahrain', label: 'Bahrain' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Sri Lanka', label: 'Sri Lanka' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2025_2026]: [
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Sri Lanka', label: 'Sri Lanka' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2026_2027_PRELIM]: [
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2026_2027]: [
        { value: 'Bahrain', label: 'Bahrain' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'Cambodia', label: 'Cambodia' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
    [SURVEY_YEAR_2027_PRELIM]: [
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'China', label: 'China' },
        { value: 'Hong Kong', label: 'Hong Kong' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'Sri Lanka', label: 'Sri Lanka' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates (UAE)' },
        { value: 'Vietnam', label: 'Vietnam' },
    ],
}

const EUROPE_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2023]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2023_2024]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2024]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        { value: 'Cyprus', label: 'Cyprus' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2024_2025]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2025]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2025_2026_PRELIM]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2025_2026]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2026_2027]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        { value: 'Cyprus', label: 'Cyprus' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Gibraltar', label: 'Gibraltar' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Malta', label: 'Malta' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
    [SURVEY_YEAR_2027_PRELIM]: [
        { value: 'Austria', label: 'Austria' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Croatia', label: 'Croatia' },
        {
            value: 'Czechia (Czech Republic)',
            label: 'Czechia (Czech Republic)',
        },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Kingdom', label: 'United Kingdom (UK)' },
    ],
}

const OCEANIA_COUNTRY_LIST = {
    [SURVEY_YEAR_2022_2023]: [
        { value: 'Australia', label: 'Australia' },
        { value: 'New Zealand', label: 'New Zealand' },
    ],
}

export const GROUPED_COUNTRY_OPTIONS = {
    [SURVEY_YEAR_2022_2023]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2023_PRELIM]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2023]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2023_2024]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2023_2024],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2023_2024],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2023_2024],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2023_2024],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2024]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2024],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2024],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2024],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2024],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2024_2025]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2024_2025],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2024_2025],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2024_2025],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2024_2025],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2025]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2025],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2025],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2025],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2025],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2025_2026_PRELIM]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2025_2026_PRELIM],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2025_2026_PRELIM],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2025_2026_PRELIM],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2025_2026_PRELIM],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2025_2026]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2026_PRELIM]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2026_PRELIM],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2026]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2026_PRELIM],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2026_2027_PRELIM]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2026_2027_PRELIM],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2026_2027_PRELIM],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2026_2027_PRELIM],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2025_2026],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2026_2027]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2026_2027],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2026_2027],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2026_2027],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2026_2027],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
    [SURVEY_YEAR_2027_PRELIM]: [
        {
            label: 'North America',
            options: NORTH_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
        {
            label: 'Latin America',
            options: LATIN_AMERICA_COUNTRY_LIST[SURVEY_YEAR_2027_PRELIM],
        },
        {
            label: 'Africa',
            options: AFRICA_COUNTRY_LIST[SURVEY_YEAR_2027_PRELIM],
        },
        {
            label: 'Asia',
            options: ASIA_COUNTY_LIST[SURVEY_YEAR_2027_PRELIM],
        },
        {
            label: 'Europe',
            options: EUROPE_COUNTRY_LIST[SURVEY_YEAR_2027_PRELIM],
        },
        {
            label: 'Oceania',
            options: OCEANIA_COUNTRY_LIST[SURVEY_YEAR_2022_2023],
        },
    ],
}
